import React from 'react';
import Icon, { IIcon } from './Icon';

const AndroidIcon: React.FC<IIcon> = props => (
  <Icon width="18" height="24" viewBox="0 0 18 24" fill="none" {...props}>
    <g clipPath="url(#clip0)">
      <path
        d="M0.369675 2.31709C0.112836 2.61987 -0.0182151 3.00907 0.00335185 3.40503V20.5945C-0.0231683 20.9911 0.10849 21.3821 0.369675 21.6824L0.424233 21.7446L10.0811 12.1163V11.8832L0.424233 2.2627L0.369675 2.31709Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M13.2757 15.3253L10.0801 12.1159V11.8828L13.2757 8.67334L13.3458 8.71997L17.1727 10.8803C18.2639 11.4942 18.2639 12.5044 17.1727 13.1261L13.3614 15.2865L13.2757 15.3253Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M13.3697 15.2779L10.0806 11.9985L0.369141 21.6812C0.589382 21.8767 0.871287 21.9891 1.16597 21.9991C1.46066 22.009 1.74954 21.9158 1.98252 21.7356L13.3697 15.2779Z"
        fill="url(#paint2_linear)"
      />
      <path
        d="M13.3697 8.72009L1.98252 2.27015C1.75105 2.08747 1.4624 1.992 1.16731 2.00053C0.872227 2.00905 0.589604 2.12104 0.369141 2.31678L10.0806 11.9995L13.3697 8.72009Z"
        fill="url(#paint3_linear)"
      />
      <path
        opacity="0.2"
        d="M13.2762 15.209L1.98252 21.6201C1.758 21.789 1.48439 21.8804 1.20311 21.8804C0.921829 21.8804 0.648212 21.789 0.423699 21.6201L0.369141 21.6745L0.423699 21.7366C0.648212 21.9056 0.921829 21.997 1.20311 21.997C1.48439 21.997 1.758 21.9056 1.98252 21.7366L13.3697 15.2789L13.2762 15.209Z"
        fill="black"
      />
      <path
        opacity="0.12"
        d="M0.368896 21.5733C0.118545 21.265 -0.00414343 20.873 0.0259559 20.4775V20.5941C-0.000564344 20.9907 0.131093 21.3817 0.392278 21.682L0.446837 21.6276L0.368896 21.5733Z"
        fill="black"
      />
      <path
        opacity="0.12"
        d="M17.1724 13.0088L13.2754 15.208L13.3455 15.2779L17.1724 13.1176C17.3983 13.0223 17.5943 12.8681 17.7397 12.6712C17.8851 12.4743 17.9745 12.2419 17.9986 11.9985C17.9499 12.2197 17.8497 12.4263 17.7062 12.6018C17.5627 12.7773 17.3799 12.9167 17.1724 13.0088Z"
        fill="black"
      />
      <path
        opacity="0.25"
        d="M1.98361 2.3801L17.1743 10.9904C17.3817 11.0825 17.5646 11.2219 17.7081 11.3974C17.8516 11.5728 17.9517 11.7795 18.0005 12.0006C17.9764 11.7573 17.8869 11.5249 17.7415 11.3279C17.5961 11.131 17.4002 10.9768 17.1743 10.8816L1.98361 2.27131C0.900228 1.64963 0.00390625 2.16251 0.00390625 3.40587V3.52244C0.0272885 2.27908 0.900228 1.76619 1.98361 2.3801Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="9.22376"
        y1="3.2263"
        x2="-3.81593"
        y2="16.3047"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A0FF" />
        <stop offset="0.01" stopColor="#00A1FF" />
        <stop offset="0.26" stopColor="#00BEFF" />
        <stop offset="0.51" stopColor="#00D2FF" />
        <stop offset="0.76" stopColor="#00DFFF" />
        <stop offset="1" stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="18.599"
        y1="11.9993"
        x2="-0.254887"
        y2="11.9993"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE000" />
        <stop offset="0.41" stopColor="#FFBD00" />
        <stop offset="0.78" stopColor="#FFA500" />
        <stop offset="1" stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="11.5848"
        y1="13.7859"
        x2="-6.10192"
        y2="31.5174"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3A44" />
        <stop offset="1" stopColor="#C31162" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="-2.0782"
        y1="-3.40268"
        x2="5.8171"
        y2="4.51608"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32A071" />
        <stop offset="0.07" stopColor="#2DA771" />
        <stop offset="0.48" stopColor="#15CF74" />
        <stop offset="0.8" stopColor="#06E775" />
        <stop offset="1" stopColor="#00F076" />
      </linearGradient>
      <clipPath id="clip0">
        <rect width="18" height="24" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export default AndroidIcon;
